import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { PAYMENT_DROPOFFS } from '@constants/routes';

const PaymentDropoffPage = lazy(
  () =>
    import('@features/payment-dropoff/pages/payment-dropoff/PaymentDropoffPage')
);

export const PaymentDropoffRoutes: RouteObject[] = [
  {
    path: PAYMENT_DROPOFFS.HOME,
    element: <PaymentDropoffPage />
  }
];

export default PaymentDropoffRoutes;
